import React from 'react';
import TopNav from '../../components/TopNav';
import CatchDonor from '../../images/catch/catch_donor.jpg';
import CatchDonor2x from '../../images/catch/catch_donor@2x.jpg';

const Header = () => {
  return (
    <header>
      <TopNav />
      <div className="catch sub">
        <img
          src={ CatchDonor }
          srcSet={ `${ CatchDonor } 1x, ${ CatchDonor2x } 2x` }
          alt="こだわり検索結果"
        />
      </div>
    </header>
  );
}

export default Header;
